export default __webpack_public_path__ + "static/media/Github.b97fef48.svg";